'use client';

import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";

import { Layout } from "./components/common/layout";
import { Home } from "./components/pages/Home";
import { Callback } from "./components/pages/Callback";

import InviteGateModal from "./components/InviteGateModal";
import InviteGateExact from "./components/InviteGateExact";

// Lazy load route components
const Pattern = React.lazy(() => import("./components/pages/Pattern").then(m => ({ default: m.Pattern })));
const CreatePattern = React.lazy(() => import("./components/pages/CreatePattern").then(m => ({ default: m.CreatePattern })));
const PatternPreview = React.lazy(() => import("./components/pages/CreatePattern").then(m => ({ default: m.PatternPreview })));
const EditPattern = React.lazy(() => import("./components/pages/EditPattern").then(m => ({ default: m.EditPattern })));
const Profile = React.lazy(() => import("./components/pages/Profile").then(m => ({ default: m.Profile })));
const CreateProfile = React.lazy(() => import("./components/pages/CreateProfile").then(m => ({ default: m.CreateProfile })));
const EditProfile = React.lazy(() => import("./components/pages/EditProfile").then(m => ({ default: m.EditProfile })));
const UserSettings = React.lazy(() => import("./components/pages/UserSettings/UserSettings"));
const NotificationCenter = React.lazy(() => import("./components/pages/NotificationCenter").then(m => ({ default: m.NotificationCenter })));
const SearchResults = React.lazy(() => import("./components/pages/SearchResults").then(m => ({ default: m.SearchResults })));
const ModerationDashboard = React.lazy(() => import("./components/pages/Moderation/ModerationDashboard").then(m => ({ default: m.ModerationDashboard })));
const ModerationPreview = React.lazy(() => import("./components/pages/Moderation/ModerationPreview").then(m => ({ default: m.ModerationPreview })));
const UserAnalysisPage = React.lazy(() => import("./components/pages/UserAnalysis").then(m => ({ default: m.UserAnalysisPage })));
const Roadmap = React.lazy(() => import("./components/pages/Roadmap").then(m => ({ default: m.Roadmap })));
const CraftRoom = React.lazy(() => import("./components/pages/CraftRoom").then(m => ({ default: m.CraftRoom })));
const CreateCraftProjectPage = React.lazy(() => import("./components/pages/CraftRoom/CreateCraftProjectPage").then(m => ({ default: m.CreateCraftProjectPage })));
const CraftProjectDetailPage = React.lazy(() => import("./components/pages/CraftRoom/CraftProjectDetailPage"));
const EditCraftProjectPage = React.lazy(() => import("./components/pages/CraftRoom/EditCraftProjectPage"));
const MaterialCreationPage = React.lazy(() => import("./components/pages/CraftRoom/MaterialCreationPage"));
const MaterialDetailPage = React.lazy(() => import("./components/pages/Material/MaterialDetailPage"));
const InventoryPage = React.lazy(() => import("./components/pages/Inventory/InventoryPage").then(m => ({ default: m.InventoryPage })));

// Loading component
const PageLoader = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    minHeight: '200px',
    color: '#666'
  }}>
    Loading...
  </div>
);


import './App.css';
import './styles/dnd-fixes.css';
import './styles/loading.css';
// import "./styles/profile-theme.css";

const App = () => {
  // DEBUG: App component debugging
  console.log('[APP] hostname:', window.location.hostname);
  console.log('[APP] always showing gate now');
  
  const appContent = (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="callback" element={<Callback />} />

        <Route path="pattern/:patternId/:slug?" element={<Suspense fallback={<PageLoader />}><Pattern /></Suspense>} />
        <Route path="pattern/draft/preview/:patternId" element={<Suspense fallback={<PageLoader />}><PatternPreview /></Suspense>} />
        <Route path="pattern/temp/preview/:patternId" element={<Suspense fallback={<PageLoader />}><PatternPreview /></Suspense>} />
        <Route path="author/:screenName" element={<Suspense fallback={<PageLoader />}><Profile /></Suspense>} />
        <Route path="create" element={<Suspense fallback={<PageLoader />}><CreatePattern /></Suspense>} />
        <Route path="edit/:patternId/:slug?" element={<Suspense fallback={<PageLoader />}><EditPattern /></Suspense>} />
        <Route path="create/profile" element={<Suspense fallback={<PageLoader />}><CreateProfile /></Suspense>} />
        <Route path="edit/profile/:screenName" element={<Suspense fallback={<PageLoader />}><EditProfile /></Suspense>} />
        <Route path="settings" element={<Suspense fallback={<PageLoader />}><UserSettings /></Suspense>} />
        <Route path="notifications" element={<Suspense fallback={<PageLoader />}><NotificationCenter /></Suspense>} />
        <Route path="search" element={<Suspense fallback={<PageLoader />}><SearchResults /></Suspense>} />
        <Route path="moderation" element={<Suspense fallback={<PageLoader />}><ModerationDashboard /></Suspense>} />
        <Route path="moderation/preview/:snapshotId" element={<Suspense fallback={<PageLoader />}><ModerationPreview /></Suspense>} />
        <Route path="moderation/user/:userId/analysis" element={<Suspense fallback={<PageLoader />}><UserAnalysisPage /></Suspense>} />
        <Route path="roadmap" element={<Suspense fallback={<PageLoader />}><Roadmap /></Suspense>} />
        <Route path="craft-rooms/:screenName" element={<Suspense fallback={<PageLoader />}><CraftRoom /></Suspense>} />
        <Route path="materials/:materialId/:materialSlug" element={<Suspense fallback={<PageLoader />}><MaterialDetailPage /></Suspense>} />
        <Route path="materials/create" element={<Suspense fallback={<PageLoader />}><MaterialCreationPage /></Suspense>} />
        <Route path="craft-room/materials/add" element={<Suspense fallback={<PageLoader />}><MaterialCreationPage /></Suspense>} />
        <Route path="craft-projects/create" element={<Suspense fallback={<PageLoader />}><CreateCraftProjectPage /></Suspense>} />
        <Route path="craft-projects/:projectId" element={<Suspense fallback={<PageLoader />}><CraftProjectDetailPage /></Suspense>} />
        <Route path="craft-projects/:projectId/edit" element={<Suspense fallback={<PageLoader />}><EditCraftProjectPage /></Suspense>} />
        <Route path="inventory" element={<Suspense fallback={<PageLoader />}><InventoryPage /></Suspense>} />
      </Route>
    </Routes>
  );

  return (
    <>
      <InviteGateExact />
      {appContent}
    </>
  );
};
export default App;
